export const en = {
  eventDate: {
    ended: "The event has ended.",
    register: "Have you registered?",
    start: "The event starts {0}"
  },
  activationCodeScreen: {
    text1: "Girmiş olduğunuz aktivasyon koduna ait {0} e-posta adresiyle daha önce hesap oluşturduğunuz için bu hesaba ait şifrenizi girmeniz gerekmektedir.",
    text2: "{0} adresine bağlı hesabınızın şifresini hatırlamıyorsanız buraya tıklayarak şifrenizin e-posta adresine gönderimini sağlayabilirsiniz. ŞİFREMİ GÖNDER",
    text3: "",
    text4: "",
    text5: ""
  },
  wait: "Please Wait",
  filter: "Filter...",
  search: "Search...",
  refresh: "Refresh",
  close: "Close",
  add: "Add",
  choose: "Choose...",
  emailRequiredFastLogin: "Please enter your e-mail address.",
  passwordRequiredFastLogin: "Please enter your account password.",
  contentNotFound: "No content has been published yet.",
  contentFilterNotFound: "There is no content matching the search or filter criteria.",
  welcome: "Welcome",
  legal: "Legal",
  app: "App",
  recommendFriend: "Recommend to your friend",
  sendFeedback: "Send feedback",
  rateUs: "Rate us",
  aboutApp: "About the app",
  showMore: "Show more",
  header: {
    welcome: "Welcome, <strong>{name}</strong>",
    myaccount: "My Profile",
    profilesettings: "Profile Settings",
    accountsettings: "Account Settings",
    logout: "Logout",
    passwordsettings: "Password Settings",
    contacts: "Contacts"
  },
  policies: {
    kvkk: "GDPR",
    privacyPolicy: "Privacy Policy",
    termsOfUse: "Term Of Use",
    cookiePolicies: "Cookie Policy"
  },
  account_bar: {
    fullscreen: "Full Screen",
    normal_screen: "Normal Screen",
    messages: "Messages",
    my_account: "My Account",
    notifications: "Notifications",
    side_bar_open: "Side bar Open/Close"
  },
  meetControls: {
    toggleCam: "Toggle webcam",
    toggleMic: "Toggle mic",
    toggleSocialHub: "Toggle social hub",
    inviteSomeone: "Invite someone",
    openSettings: "Open settings",
    sharePresentation: "Share presentation",
    shareVideo: "Share video",
    leaveRoom: "Leave room",
    leaveRoomSureMsg: "Are you sure want to leave this room?",
    confirmLeave: "Yes, leave",
    cancelLeave: "No, stay here",
    settings: "Settings"
  },
  inviteToRoom: "Invite to room",
  account_settings: {
    settings: "Settings",
    profile: {
      title: "Profile",
      settings: "Profile settings",
      visibleDesc: "Your profile is private. Other attendees cannot view your profile information.",
      visible: "Public",
      invisibleDesc: "Your profile is not viewable. The information you share in this section cannot be viewed by other people in searches and matches.",
      invisible: "Private",
      show_busy: "Show me busy",
      my_linked_account: "Show my linked accounts",
      email: "E-mail"
    },
    account: {
      title: "Account",
      description: "Your account is secure. You updated your account information on {date}. If you have made a change, please edit it.",
      language: "Language",
      tr: "Turkish",
      en: "English",
      account_transactions: "Account",
      delete_account: "Delete my account"
    },
    password: {
      title: "Password",
      password_transactions: "Change password",
      description: "You last updated your password on {date}. We recommend that you change your password every six months for your account security.",
      never_updated_password: "You created your password on {date}, and never updated it. For your account security, change your password every six months."
    }
  },

  contacts_hub: {
    title: "Contacts hub",
    menu: {
      messages: {
        title: "Messages",
        select_message: "Select a chat on the left to view the messages."
      },
      contacts: {
        title: "Contacts"
      },
      suggestions: {
        title: "Suggestions"
      }
    }
  },
  swallFireNotify: {
    warning: "Warning",
    content: "Please answer this question"
  },
  program: {
    title: "Program",
    menu: {
      details: "Details",
      reviews: "Reviews",
      attendees: "Attendees",
      appreciations: "Reviews",
      alreadyRate: "You have reviewed this session.",
      speakers: "Speakers",
      closedRegister: "Registrations are closed.",
      participants: "Participants"
    }
  },
  socialfeed: {
    title: "Limited access",
    desc: "You must be an attendee of this event to see the social hub."
  },
  countdown: {
    days: "Day",
    hours: "Hour",
    minutes: "Minute",
    seconds: "Second"
  },
  camera_settings: {
    title: "Prepare for broadcast",
    camera: "Camera",
    no_camera: "No camera found",
    microphone: "Microphone",
    no_microphone: "No microphone found",
    speaker: "Speaker",
    no_speaker: "No speaker found",
    auto_open: "Auto open",
    refresh_screen: "Reload page",
    chrome_info: "Learn how to do  in Chrome browser",
    safari_info: "Learn how to do  in Safari browser",
    okey: "Everything OK!"
  },
  deviceConnectionErrors: {
    notFound: "No camera or microphone found connected to the computer.",
    noCameraFound: "You have no connected cameras. Please check your camera connection.",
    noMicFound: "You have no connected microphones. Please check your microphone connection.",
    noOutputDevice: "You have no connected output device found. Please connect a speaker or headphones.",
    notReadable: "Your camera or microphone is being used by another application.",
    notAllowed: "Please grant camera and microphone access permissions in your browser.",
    openPermissions: "You can open the permissions when you click on 'Secure' in your browser's address bar.",
    unexpectedProblem: "We are experiencing an unexpected problem while accessing your camera and microphone."
  },
  speaker: {
    title: "Speaker Profile",
    sessions_speaker: "Sessions as a speaker",
    speaker_camera_off: "Speaker's camera is off",
    speaker_microphone_off: "Speaker's microphone is off"
  },
  speakerSteps: {
    tour1: "You can turn your microphone and camera on or off using these buttons. To share your screen, use the button on the right.",
    tour2: "Use this button to share a presentation",
    tour3: "Use this button to share a video",
    tour4: "You can save space by narrowing the area on the right.",
    tour5: "You can make the application full screen by using this button.",
    tour6: "You can view the messages from other participants and send messages here.",
    tour7: "You can access all announcements, information and news about the event in this notifications section.",
    invite_step: "You can invite other participants to your networking table and make video and audio calls by clicking this button."
  },
  homeTourSteps: {
    tour1: "You can quickly access live sessions here.",
    tour2: "This is the Reception area where you can access all the event details.",
    tour3: "You can access all live broadcast sessions here. You can also see if there are sessions that you are the speaker.",
    tour4: "You can have live meetings and make presentations with other participants at the tables in this area.",
    tour5: "You can visit the virtual stands at the event and participate in the activities held at the stands."
  },
  tourButton: {
    buttonSkip: "Skip Tour",
    buttonPrevious: "Previous",
    buttonNext: "Next",
    buttonStop: "Finish"
  },
  appointment: {
    title: "Make an appointment",
    expired_date: "The event has finished. You cannot arrange any appointments.",
    cannot_select: "You can not select event.",
    cannot_add_participant: "You can not add participant.",
    appointment_time_full: "Appoinment time is full",
    appointment_times: "Appoinment Times",
    must_choose_date: "You should choose a date",
    event_name: "Event Name",
    appointment_subject: "Appointment Subject",
    appointment_date: "Appointment Date",
    appointment_hour: "Appointment Time",
    appointment_duration: "Appointment Duration",
    appointment_venue: "Appointment Venue",
    first_of_all_pick_event: "Please select an appointment first",
    people: "Contacts",
    appointments: "Appoinments",
    create: "Create",
    empty_appointment_list: "You have no appointments",
    pending: "Pending",
    coming: "Upcoming Appointments",
    past: "Past and Denied Appointments",
    collapse: "Narrow down",
    see_profile: "View Appointer's Profile",
    approve: "Approve",
    remove: "Remove",
    reject: "Deny",
    no_pending: "You have no scheduled appointments.",
    no_coming: "You have no upcoming appointments.",
    no_past: "You have no past appointments.",
    join_only_you: "You are the only person attending",
    you_and_value: "You and {0} are attending.",
    pending_person: "Pending",
    join_person: "Attending",
    reject_person: "Not attending",
    notifications: "Notifications",
    appointments: "Appointments",
    no_notifications: "You have no notifications.",
    search_person: "Search Person...",
    close_dialog: "Close",
    save: "Save",
    b2b: "B2B",
  },
  login: {
    completeRegister: "Complete Registration",
    title: "Live Event Experience",
    description: "Create your account now for an interactive and enjoyable event experience at Holacon",
    email: {
      title: "Email"
    },
    password: {
      title: "Password"
    },
    forgot_password: "Forgot your password?",
    login: "Login",
    back: "Back",
    facebook: "Login with Facebook",
    activationCode: "Activation code",
    fastLogin: "Activation code",
    fastLoginBtn: "Sign in",
    withemailpass: "Email & Password",
    useactiveemail: "Please enter an active e-mail address.",
    activationinfo: "You can access the event by entering your 13-digit activation code in your voucher sent to you via e-mail or SMS.",
    usesocialacc: "Login / Signin with social accounts",
    desc: "It's great to see you back!",
    desc2: "To access all events linked you to your account, log in",
    downloadapp: "Download mobile app",
    welcome: "Welcome!"
  },
  register: {
    title: "Live Event Experience",
    description: "You can see all the events you have attended so far, and you can attend to any events by entering the activation code.",
    email: "Email",
    password: "Password",
    passwordRetry: "Password (Retype)",
    forgot_password: "Forgot your password?",
    firstName: "Name",
    lastName: "Surname",
    backButton: "Go Back",
    register: "Register",
    desc: "You can link all the events you attend to a single account."
  },
  forgot: {
    title: "Live Event Experience",
    description: "You can see all the events you have attended so far, and you can attend to any events by entering the activation code.",
    email: "Email",
    password: "Password",
    passwordRetry: "Password (Retype)",
    forgot_password: "Forgot My Password",
    resetToken: "Reset Code",
    lastName: "Surname",
    forgot: "Reset My Password",
    resend: "Resend",
    desc: "You can create your new password using numbers, letters, and special characters for your account security."
  },
  event: {
    where_when: "It will take place at <strong> {where} </strong> on <strong> {when} </strong>.",
    where_not_when: "It will take place on <strong>{when}</strong>.",
    menu: {
      goback: "Go back",
      about: "About",
      speakers: "Speakers",
      program: "Program",
      sponsors: "Sponsors",
      questions: "F.A.Q.",
      documents: "Documents",
      surveys: "Surveys",
      gallery: "Photo Album",
      ask: "Ask to Speakers",
      poll: "Live Voting",
      social: "Social Hub",
      participants: "Attendees"
    },
    headerinfo: {
      title: "Activation required",
      activation1: "",
      activation2: " Click ",
      activation3: "to use the activation code.",
      ticket1: "",
      ticket2: "Click ",
      ticket3: "to register for the event or buy tickets.",
      contact1: "Online registrations are closed.",
      contact2: " Click ",
      contact3: "to contact the organizer."
    },
    speakers: {
      title: "Speakers",
      description: "You can see the speakers here.",
      refresh: "Refresh"
    },
    program: {
      title: "Event Program",
      description: "You can see the event program here.",
      refresh: "Refresh",
      reset: "Reset filter",
      filter_title: "No results found",
      filter_today_title: "There is no program today",
      all_saloons: "All Venues",
      search_placeholder: "Search Program & Speaker",
      subevent_filter: "You are reviewing program of the {title} subevent",
      sub_event_register: "Register for the sub-event"
    },
    sponsor: {
      title: "Sponsors",
      description: "You can see the sponsors here.",
      refresh: "Refresh"
    },
    question: {
      title: "Frequently Asked Questions",
      description: "You can see the F.A.Qs",
      refresh: "Refresh"
    },
    document: {
      title: "Documents",
      description: "You can see the documents here.",
      refresh: "Refresh",
      reset: "Reset Filter",
      filter_title: "No results found",
      search_placeholder: "Search Docs",
      all: "All",
      reset2: "Reset"
    },

    survey: {
      title: "Surveys",
      description: "You can see the surveys here.",
      refresh: "Refresh",
      completed: "You have previously participated in this survey.",
      answer: "Type Your Answer Here",
      complete: "Complete the survey",
      next: "Next",
      placeholder: "Type Your Answer Here"
    },
    gallery: {
      title: "Photo Album",
      description: "You can see the photo album here",
      refresh: "Refresh"
    },
    poll: {
      description: "It will be displayed here when any live voting starts."
    }
  },
  sessions: {
    join: "JOIN",
    watcherCount: "({watcherCount})",
    live: "LIVE",
    waiting: "AWAITING",
    info_title: "Live sessions",
    info_description: "You can see all the live broadcast sessions of the event in this area. You can join and watch sessions depending on your registration status.",
    speaker: {
      title: "Session(s) in which you are a speaker:",
      description: "These are the sessions in which you are the speaker. <br> You can log into pre-broadcast sessions and rehearse."
    },
    participant: {
      title: "Session(s) that you are attending:",
      description: "These are the sessions that your are attending.<br>"
    }
  },
  askspeaker: {
    nomore: "No more questions",
    nodata: "There is no question yet",
    share: "Ask a question"
  },
  downloadapp: {
    title: "Download the App",
    description: "Download our app to use this feature and many others."
  },
  settings: {
    addnew: "New",
    general_title: "General Settings",
    email: "Email",
    add_new: "Add",
    cellPhone: "Mobile Phone",
    about: "About",
    save: "Save",
    job_title: "Job",
    new: "New",
    jobs_description: "All information on your profile will display as public.",
    firmName: "Company Title",
    position: "Position",
    dateStart: "Starting Date",
    dateEnd: "Due Date",
    dateEndPlaceholder: "Due Date (Leave blank if you continue)",
    date_format: "DD / MM / YYYY",
    no_end: "Continuing",
    edit: "Edit",
    remove: "Remove",
    school_title: "Education",
    school_description: "All information on your profile will display as public.",
    title: "Title",
    department: "Department",
    interest_title: "Interests",
    interest_description: "All information on your profile will display as public.",
    search_interest: "Search interests...",
    close: "Close",
    country: "Country",
    country_error: "Please enter a valid phone number",
    phone: "Phone number",
    example: "For Eg. :",
    school: "School"
  },
  password: {
    currentPassword: "Current Password",
    newPassword: "New password",
    newPasswordRetry: "New password (retype) ",
    passwordChangeAttention: "For your security, we recommend that you update your password every 6 months.",
    passwordLastChange: "Last time you have updated your password on ",
    passwordNotChanged: "You not changed password before."
  },
  save: "Save",
  change_image: "Change image",
  home: {
    joined_description: "All the events you attended. <br /> You can access your events by entering the activation code in your Voucher.",
    joined_title: "Events You Attended",
    join: "Activate Event",
    date_format: "will be held on <strong> {venue} </strong> on <strong> {date} </strong>",
    activate: "Activate Event",
    activateInfo1: "You can activate the event by entering your 13-digit activation code in the voucher sent to you via e-mail or SMS.",
    activateInfo2: "This process is one-time and you do not need to re-activate it again.",
    activateInfo3: "If you have not received the activation code, you can contact the organizer."
  },
  do_activate: "Activate",
  pending: "Pending",
  rejected: "Denied",
  microphone_info: "You can turn your microphone and camera on or off or start screen sharing from this section.",
  networking: {
    title: "Networking Area",
    description: "You can make live meetings with other attendees in the networking rooms. You can view each table's occupancy status and attendees and join available rooms.",
    lock_open: "Open",
    lock_closed: "Full"
  },
  stands: {
    title: "Exhibitions area",
    all: "All",
    description: "In this section, you can see the foyer areas and booth pages. You can tour the foyer areas, visit the booth pages and have a virtual meeting with booth attendants."
  },
  close: "Close",
  vote: {
    dovote: "Vote"
  },
  leftmenu: {
    reception: "Reception",
    sessions: "Sessions",
    networking: "Networking",
    stands: "Exhibitions"
  },
  poll: {
    select_answer: "Select an answer"
  },
  tabBar: {
    events_attended: "Events I Attended",
    upcoming_events: "Upcoming Events",
    past_events: "Past Events"
  },
  recursiveQuestionBuilder: {
    dragClick: "Drag or <em>click</em> to upload.",
    dragMsg: "files with a size less than"
  },
  checking_in: "Checking in",
  check_in: "Check-in",
  checked_in: "Checked-in",
  noroom: "There isn't any available room in the networking areas right now. Please try again later.",
  write_rate_here: "Write a comment...",
  your_rate: "Your Rate",
  send: "Send",
  phone_not_confirmed: "Phone number is not verified.",
  email_not_confirmed: "Email is not verified.",
  confirm_now: "Verify now",
  write_key: "Enter code",
  confirm: "Confirm",
  email_confirmed: "You have verified your email address.",
  phone_confirmed: "You have verified your phone number",
  write_message: "Type your message...",
  send_network_req: "Send Networking Request",
  network_request_received: "{name} sent you a networking request",
  network_req_message: "A video call request has been sent.",
  accept: "Accept",
  reject: "Reject",
  showNotifications: "Show notifications",
  job: "Job",
  school: "Education",
  register_limit: "Participation is limited to {stock} people.",
  subevent_confirmed: "Your participation request has been approved",
  subevent_pending: "Your request is pending approval",
  image_uploaded: "Photo Uploaded",
  share: "Post something",
  message_sent: "Message Sent.",
  nochat: "There is no chat.",
  nomobilesupport: "This app does not have mobile compatibility support for now.",
  add_calendar: "Add to Calendar",
  rate_program: "Rate Program",
  program_rated: "Program Rated",
  search_contacts: "Search contacts",
  search_suggestion: "Search within recommendations",
  contacts: "My Contacts",
  contacts_no_data: "You can see your contacts here",
  contacts_remove: "Are you sure you want to delete this contact?",
  announcement: "Announcement",
  announcements: "Announcements",
  share_a_post: "Share a post",
  nomorepost: "No more posts",
  nopost: "No posts shared yet.",
  delete: "Delete",
  notifications: {
    menu: {
      notifications: "Notifications",
      appointments: "Appointments"
    },
    events: {
      delete: "Delete",
      mark_as_read: "Mark as read",
      delete_all: "Delete all",
      mark_all: "Mark all as read"
    },
    no_notifications: "No notifications"
  },

  nodatakeys: {
    speakers: {
      nodatatitle: "Speakers",
      nodatadesc: "The speakers have not been published yet.",
      nodatabutton: "Refresh",
      nofilterdatatitle: "Speakers",
      nofilterdatadesc: "No results were found matching your search criteria.",
      nofilterdatabutton: "Reset filter"
    },
    program: {
      nodatatitle: "Program",
      nodatadesc: "Program flow and sessions are not published.",
      nodatabutton: "Refresh",
      nofilterdatatitle: "Program",
      nofilterdatadesc: "No results were found matching your search criteria.",
      nofilterdatabutton: "Reset filter",
      daydatatitle: "Program",
      daydatadesc: "No results were found matching your search criteria.",
      daydatabutton: "Refresh"
    },
    sponsors: {
      nodatatitle: "Sponsors",
      nodatadesc: "The event sponsors have not been published.",
      nodatabutton: "Refresh"
    },
    attendees: {
      nodatatitle: "Attendees",
      nodatadesc: "There are no active attendees at the event yet.",
      nodatabutton: "Refresh",
      nofilterdatatitle: "Attendees",
      nofilterdatadesc: "No results were found matching your search criteria.",
      nofilterdatabutton: "Reset filter",
      noaccesstitle: "Attendees",
      noaccessdesc: "The interaction of the attendees is restricted in this event.",
      noaccessbutton: "Return"
    },
    sessions: {
      nodatatitle: "Live sessions",
      nodatadesc: "There is no active live session.",
      nodatabutton: "Refresh"
    },
    networking: {
      nodatatitle: "Networking area",
      nodatadesc: "There is no active networking area.",
      nodatabutton: "Refresh"
    },
    gallery: {
      nodatatitle: "Photo album",
      nodatadesc: "No photos have been shared yet.",
      nodatabutton: "Refresh"
    },
    surveys: {
      nodatatitle: "Surveys",
      nodatadesc: "There is no survey to participate in.",
      nodatabutton: "Refresh"
    },
    maps: {
      nodatatitle: "Area maps",
      nodatadesc: "No area maps have been published yet.",
      nodatabutton: "Refresh"
    },
    faq: {
      nodatatitle: "Frequently asked questions",
      nodatadesc: "There is no content in this section.",
      nodatabutton: "Refresh"
    },
    documents: {
      nodatatitle: "Documents",
      nodatadesc: "No documents have been shared yet.",
      nodatabutton: "Refresh",
      nofilterdatatitle: "Documents",
      nofilterdatadesc: "No results were found matching your criteria.",
      nofilterdatabutton: "Reset filter"
    },
    expo: {
      nodatatitle: "Expo",
      nodatadesc: "There ara no booths at Expo area.",
      nodatabutton: "Refresh",
      nofilterdatatitle: "Expo",
      nofilterdatadesc: "No results were found matching your criteria.",
      nofilterdatabutton: "Reset filter"
    },
    asktospeakers: {
      nodatatitle: "Ask to speaker",
      nodatadesc: "No topic has been published yet.",
      nofilterdatatitle: "Ask to speaker",
      nofilterdatadesc: "No questions asked yet. Be the first and ask now!"
    },
    polls: {
      nodatatitle: "Live voting",
      nodatadesc: "When a live voting starts, you can access here."
    },
    subeventattendees: {
      nodatatitle: "Sub-event attendees",
      nodatadesc: "You can see other attendees participating in this sub-event here.",
      nodatabutton: "Refresh",
      nofilterdatatitle: "Sub-event attendees",
      nofilterdatadesc: "No results were found matching your criteria.",
      nofilterdatabutton: "Reset filter"
    },
    programreviews: {
      nodatatitle: "Session reviews",
      nodatadesc: "Attendees have not left any feedback or review for this session yet."
    },
    messagehub: {
      nodatatitle: "You have no messages.",
      nodatadesc: "You can contact and message other attendees.",
      nodatabutton: "Refresh"
    },
    contacts: {
      nodatatitle: "You have no contacts.",
      nodatadesc: "You can add other attendees to your network.",
      nodatabutton: "Refresh",
      nofilterdatatitle: "Contacts",
      nofilterdatadesc: "No results were found matching your criteria.",
      nofilterdatabutton: "Reset filter"
    },
    suggestions: {
      nodatatitle: "You have no suggestion",
      nodatadesc: "No suitable suggestions were found. You can expand your network by participating in and interacting with more events",
      nodatabutton: "Refresh",
      nofilterdatatitle: "Suggestions",
      nofilterdatadesc: "No results were found matching your criteria.",
      nofilterdatabutton: "Reset filter"
    },
    notifications: {
      nodatatitle: "Notifications",
      nodatadesc: "You have no notifications.",
      nodatabutton: "Refresh"
    },
    homeactivatedevents: {
      nodatatitle: "Events I attended",
      nodatadesc: "You have not participated in any events yet.",
      nodatabutton: "Refresh"
    },
    homeupcomingevents: {
      nodatatitle: "Upcoming events",
      nodatadesc: "There are no upcoming events.",
      nodatabutton: "Refresh"
    },
    homepastevents: {
      nodatatitle: "Past events",
      nodatadesc: "There are no past events.",
      nodatabutton: "Refresh"
    }
  },
  socialValid: {
    minLength: "You must enter at least {0} character",
    email: "Please enter an email in the correct format.",
    nullCheck: "Please answer the question.",
    nullCheck2: "Please select at least one answer."
  },
  filterGroupPlaceholder: "Filter by attendee group",
  block_user: "Block",
  load_more: "Load More",
  notify_warning: "Warning",
  notify_confirm: "Confirm",
  notify_cancel: "Cancel",
  volume_on_off: "Volume On/Off",
  invite_room: "Invite",
  invite: "INVITE",
  search_in: "Search attendees...",
  tag_filter: "Tag Filter",
  view_profile: "See Profile",
  clear_messages: "Clear Conversation",
  fill_blank_input: "Please fill in the blanks.",
  delete_chat: "Delete Conversation",
  no_more_message: "no more messages",
  no_message: "No messages yet",
  permission_error: "An error occurred while accessing your camera. Make sure that you full permissions for camera usage and that your camera is not used by another app. Error message:",
  camera_error: "Camera and Mic Error",
  permission_help: "Click here for help",
  stand_about: "About",
  stand_authorities: "Authorities",
  search_in_speaker: "Search Speakers ...",
  sub_event_filter: "Sub event filter",
  remove_contact: "Remove from my contacts",
  add_contact: "Add to My Contacts",
  make_appointments: "Make an appointment",
  back_surveys: "Back to Surveys",
  complete_survey: "Complete Survey",
  next: "Next",
  other_programs: "other programs linked to the {program} sub event",
  gallery: "Gallery",
  stand_surveys: "Surveys",
  sharing_now: "You are sharing your screen right now.",
  odadolu: "Cannot send invitation because this room is full.",
  notfound: "The post you tried to like has been deleted.",
  screen_permission_error: "Need system permission for screen sharing. Click on the link below to learn how.",
  permission_help_mac: "For MacOS, click here",
  virtualtour: "Virtual Tour",
  comment: "Comment",
  response: "Response",
  reply: "Reply",
  commenting: "You are commenting to ",
  searchStand: "Search stands...",
  add_calendar: "Add to calendar",
  register_and_buy_ticket: "Register / Buy a ticket",
  contact_us: "Contact Us",
  add_google_calendar: "Add to Google calendar",
  add_outlook_calendar: "Add to Outlook calendar",
  add_microsoft_calendar: "Add to Microsoft calendar",
  watch_broadcast: "Click to watch the broadcast...",
  pleaseCheckPolicy: "Please confirm the user agreements.",
  pleaseControlArea: "Please tick this field.",
  sendInvite: "Send Invite",
  no_data_text: "Data not found.",

  accountSettings: {
    settings: "Settings",
    information: "Information",
    company: "Company",
    title: "Title",
    work: "Work",
    language: "Language",
    speaking: "Speaking -",
    writing: "Writing -",
    reading: "Reading -",
    account: "Account",
    notifications: "Notifications",
    eventNotifications: "Event notifications",
    contactNotifications: "Contact notifications",
    messageNotifications: "Message notifications",
    addJob: "Add new job",
    addTutorial: "Add new tutorial",
    addLanguage: "Add new language",
    deleteAccount: "Delete account"
  },
  addLanguage: {
    language: "Language",
    speaking: "Speaking",
    writing: "Writing",
    reading: "Reading"
  },
  directions: "Directions",
  biography: "Biography",
  programs: "Programs",
  uploads: "Uploads",
  eventMemories: "Event Memories",
  chooseEvent: "Choose Event...",
  loginText: "Login",
  registerText: "Register",
  guestText: "Guest",
  loginFirst: "You must be logged in to perform this action.",
  pleaseChooseOneAttendee: "Please choose at least one attendee. You must select an event before choose a attendee.",
  socialhub: {
    topic: "TOPIC",
    comment: "comment",
    bigComment: "comment(s)",
    doComment: "Send first comment",
    reply: "reply",
    cancel: "cancel",
    likeYouAndMore: "You and {0} people liked this",
    likeYou: "You liked",
    likeMore: "{0} people liked this",
    newPost: "New Post",
    like: "Like",
    alreadyLike: "You liked",
    readMore: "Read more",
    hide: "Hide",
    surveyQuestionNumber: "The survey consists of approximately {0} questions.",
    voteEnded: "Live voting has been closed.",
    voteEnd: "Live voting ended.",
    vote: "Vote",
    voteJoinNumber: "{0} people have joined the live voting.",
    alreadyJoinSurvey: "You have participated in this survey.",
    join: "Join",
    next: "Next",
    talkingPeople: "people are talking about this topic.",
    loadMore: "Load more",
    hideComments: "Hide comments",
    hideReply: "Hide replies",
    deleteComment: "Delete comment",
    deletePost: "Delete post",

    menu: {
      hub: "Social hub",
      questionAnswer: "Q&A",
      voting: "Voting",
      survey: "Survey"
    },
    nodatatitle: "Social hub",
    nodatadesc: "No posts have been shared yet.",
    noaccesstitle: "Announcements",
    noaccessdesc: "No posts have been shared yet."
  },
  reconnect_server: "Your internet connection is not stable, trying to reconnect...",
  broadcast_connect: "Connecting to broadcast ",
  deleteMyAccount: "Why do you want to delete your account?",
  reason: "Reason",
  userProfile: {
    profileActive: "This profile is public",
    profileDeactive: "This profile is private",
    profileActiveText: "Profile is public",
    profileDeactiveText: "Profile is private",
    profileBusy: "This profile is busy",
    profileAvailable: "This profile is available now",
    profileAvailableText: "Open to communicate",
    profileBusyText: "The person may not want to be disturbed; can be in a session or an online meeting",
    add_contact: "Add to my connections",
    remove_contact: "Remove to my connections",
    block_user: "Block",
    unblock_user: "Unblock",
    speaking: "Speaking : ",
    writeRead: "Reading / Writing : ",
    language: "Language",
    info: "Info",
    sameEvents: "Common events",
    makeAppointment: "Appointment",
    b2b: "B2B matchmaking",
    appointment_request: "Appointment request"
  },
  selectTopic: "Select topic (optional)"
};



// WEBPACK FOOTER //
// ./src/language/en.js